import { IGameDialog } from "../type"
import json from "./json/dialog.json"
import Img01 from "../../../assets/img/game/dialog/q1.png"
import Img02 from "../../../assets/img/game/dialog/q2.png"
import Img03 from "../../../assets/img/game/dialog/q3.png"
import Img04 from "../../../assets/img/game/dialog/q4.png"
import Img05 from "../../../assets/img/game/dialog/q5.png"
import Img06 from "../../../assets/img/game/dialog/q6.png"

export const DIALOG_ARR: IGameDialog[] = [
    { ...json[0], image: Img01 } as unknown as IGameDialog,
    { ...json[1], image: Img02 } as unknown as IGameDialog,
    { ...json[2], image: Img03 } as unknown as IGameDialog,
    { ...json[3], image: Img04 } as unknown as IGameDialog,
    { ...json[4], image: Img05 } as unknown as IGameDialog,
    { ...json[5], image: Img06 } as unknown as IGameDialog,
]

const DIALOG_DICT = DIALOG_ARR.reduce((prev, cur) => {
    prev[cur.key] = cur
    return prev
}, {})

export default DIALOG_DICT
